var _circle, _circle2, _circle3, _circle4, _ellipse, _path, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFairMarketValueHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 131,
    viewBox: "0 0 136 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8287,
    cy: 24.2999,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 0.541177
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.936,
    cy: 36.0528,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 0.541177
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.23,
    cy: 42.0885,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 0.541177
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.641,
    cy: 62.0997,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 0.541177
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.252,
    cy: 63.4503,
    rx: 45.4235,
    ry: 45.0265,
    fill: "#787E8C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.675 63.4503C110.675 87.7572 90.7947 107.477 66.2519 107.477C41.7092 107.477 21.8284 87.7572 21.8284 63.4503C21.8284 39.1434 41.7092 19.4238 66.2519 19.4238C90.7947 19.4238 110.675 39.1434 110.675 63.4503Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.89943,
    cy: 43.0411,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 0.541177
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2053,
    cy: 117.688,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 0.541177
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.1705,
    cy: 124.994,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 0.541177
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.2886,
    cy: 116.418,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 0.541177
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 81.8177,
    cy: 114.512,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 84.9934,
    cy: 123.723,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 72.606,
    cy: 127.535,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 115.488,
    cy: 107.682,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 125.652,
    cy: 88.7824,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 119.459,
    cy: 78.9352,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 122,
    cy: 58.9235,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 127.241,
    cy: 48.1237,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 123.588,
    cy: 23.8234,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 48.6236,
    cy: 129.124,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 25.9114,
    cy: 125.947,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 29.0885,
    cy: 120.388,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 8.44154,
    cy: 94.9767,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 13.0461,
    cy: 85.1296,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 1.29383,
    cy: 59.5588,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 13.841,
    cy: 39.7062,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 16.3816,
    cy: 11.5939,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 40.6822,
    cy: 0.794118,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 71.6527,
    cy: 13.1823,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.9641,
    cy: 9.2116,
    r: 0.794118,
    fill: "#787E8C",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.946 96.7238C112.245 96.7238 111.676 96.1549 111.676 95.4532C111.676 94.7515 112.245 94.1826 112.946 94.1826",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83522 74.9645C4.53695 74.9645 5.10581 74.3957 5.10581 73.6939C5.10581 72.9922 4.53695 72.4233 3.83522 72.4233",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0998 11.5944C49.8015 11.5944 50.3704 11.0255 50.3704 10.3238C50.3704 9.62208 49.8015 9.05322 49.0998 9.05322",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9117 7.1473C79.21 7.1473 78.6411 7.71616 78.6411 8.41789C78.6411 9.11961 79.21 9.68848 79.9117 9.68848",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37583 107.762H10.3464M17.017 100.376V101.409M24.7994 107.762H25.8317M17.017 114.115V115.306M17.017 116.894V121.103M14.0788 107.762C16.0641 107.762 17.0964 104.903 17.0964 104.903C17.0964 104.903 17.4141 107.762 19.9552 107.762C18.8117 107.762 17.1758 108.794 17.017 110.859C17.017 110.859 16.8321 109.168 16.2229 108.556C15.7142 108.044 14.0788 107.762 14.0788 107.762Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.426 16.6763L114.455 16.6763M107.705 27.1587L107.785 23.0293M100.002 16.6763L98.9701 16.6763M107.705 10.4822L107.705 2.38222M110.723 16.6763C108.738 16.6763 107.705 19.5351 107.705 19.5351C107.705 19.5351 107.388 16.6763 104.847 16.6763C105.99 16.6763 107.626 15.644 107.785 13.5793C107.785 13.5793 107.97 15.2696 108.579 15.8822C109.088 16.3937 110.723 16.6763 110.723 16.6763Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8935 43.9896L41.5 38.9175H94.5L92.4483 43.9896V71.4388C92.4483 85.044 81.7344 92.6224 76.3774 94.7109C77.4716 100.678 74.5537 101.971 72.958 101.872V114.403C75.0096 115.099 79.1129 118.043 79.1129 124.249H84.2419V129.917H51.758V124.249H57.229C57.229 118.043 61.3322 115.099 63.3838 114.403V101.872C58.46 100.678 59.0526 96.6005 59.9645 94.7109C47.6548 90.4145 44.1215 77.406 43.8935 71.4388V43.9896Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8935 43.9896L41.5 38.9175H94.5L92.4483 43.9896M43.8935 43.9896H92.4483M43.8935 43.9896V71.4388C44.1215 77.406 47.6548 90.4145 59.9645 94.7109M92.4483 43.9896C92.4483 47.4705 92.4483 57.8335 92.4483 71.4388C92.4483 85.044 81.7344 92.6224 76.3774 94.7109M59.9645 94.7109H76.3774M59.9645 94.7109C59.0526 96.6005 58.46 100.678 63.3838 101.872M76.3774 94.7109C77.4716 100.678 74.5537 101.971 72.958 101.872M63.3838 114.403H72.958M63.3838 114.403V101.872M63.3838 114.403C61.3322 115.099 57.229 118.043 57.229 124.249M72.958 114.403V101.872M72.958 114.403C75.0096 115.099 79.1129 118.043 79.1129 124.249M72.958 101.872H63.3838M57.229 124.249H51.758V129.917H84.2419V124.249H79.1129M57.229 124.249H79.1129",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0489 54.8445C67.3482 53.9232 68.6517 53.9232 68.951 54.8445L71.0309 61.2457C71.1648 61.6578 71.5487 61.9367 71.9819 61.9367L78.7126 61.9367C79.6813 61.9367 80.0841 63.1763 79.3004 63.7458L73.8552 67.7019C73.5047 67.9566 73.358 68.4079 73.4919 68.82L75.5718 75.2212C75.8711 76.1425 74.8167 76.9086 74.0329 76.3392L68.5877 72.383C68.2373 72.1284 67.7627 72.1284 67.4122 72.383L61.967 76.3392C61.1833 76.9086 60.1288 76.1425 60.4281 75.2212L62.508 68.82C62.6419 68.4079 62.4952 67.9566 62.1447 67.7019L56.6995 63.7457C55.9158 63.1763 56.3186 61.9367 57.2873 61.9367L64.018 61.9367C64.4512 61.9367 64.8351 61.6578 64.969 61.2458L67.0489 54.8445Z",
    stroke: "#194590",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFairMarketValueHistory);
export default __webpack_public_path__ + "static/media/no-fair-market-value-history.057c487ed0cad2b64ffc25ca2bb7e5cf.svg";
export { ForwardRef as ReactComponent };